define('pimSearchCompareController',[
  'module',
  'underscore',
  'app',
  'jquery',
  'pimSearchCompareView',
  'entities/pim_product'
], function (
  module,
  _,
  App,
  $,
  CompareView
) {
  'use strict';

  var STORAGE_KEY = 'pim:compare:ids';
  var CONFIG_STORAGE_KEY = 'pim:compare:config';
  var MAX = 4;

  function readIds() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) { return []; }
      var arr = JSON.parse(raw);
      if (!_.isArray(arr)) { return []; }
      return _.map(arr.slice(0, MAX), function (v) { return String(v); });
    } catch (e) { return []; }
  }

  function writeIds(ids) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids || [])); } catch (e) { /* no-op */ }
  }

  function readConfigMap() {
    try {
      var raw = window.localStorage.getItem(CONFIG_STORAGE_KEY);
      var map = raw ? JSON.parse(raw) : {};
      return (map && typeof map === 'object') ? map : {};
    } catch (e) { return {}; }
  }

  function writeConfigMap(map) {
    try { window.localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(map || {})); } catch (e) { /* no-op */ }
  }

  var PimSearchCompareController = {
    showCompare: function (region) {
      var ids = readIds();
      if (!ids.length) {
        App.navigate('pim/search', {trigger: true});
        return;
      }

      var view = new CompareView({ productIds: ids });

      view.listenTo(view, 'compare:remove', _.bind(this.onRemove, this, view));
      view.listenTo(view, 'compare:clear', _.bind(this.onClear, this));

      region.show(view);
    },

    onRemove: function (view, id) {
      var ids = readIds();
      var idx = _.indexOf(ids, String(id));
      if (idx !== -1) {
        ids.splice(idx, 1);
        writeIds(ids);
      }
      // Drop only the removed product's stored selection; siblings keep theirs.
      var configs = readConfigMap();
      if (configs[String(id)]) {
        delete configs[String(id)];
        writeConfigMap(configs);
      }
      if (!ids.length) {
        App.navigate('pim/search', {trigger: true});
        return;
      }
      view.options.productIds = ids;
      view.render();
    },

    onClear: function () {
      writeIds([]);
      writeConfigMap({});
      App.navigate('pim/search', {trigger: true});
    }
  };

  module.exports = PimSearchCompareController;
});

